import { NgModule } from '@angular/core';
import { UserEffects } from '@campus/public-portal';
import { EffectsModule } from '@ngrx/effects';
import { AppAuthEffects } from './state/auth/app-auth.effects';

@NgModule({
  imports: [EffectsModule.forRoot([]), EffectsModule.forFeature([UserEffects, AppAuthEffects])],
})
export class AppEffectsModule {}
